import {Trans} from '@lingui/macro';
import {Divider} from '@material-ui/core';
import React from 'react';
import CollaboratorReadOnly from '../components/CollaboratorReadOnly';

const CollaboReadOnlyPage = () => {
  return (
    <>
      <h2 className="TitleGrid">
        <Trans>Colaboradores por capacitacion</Trans>
      </h2>
      <Divider variant="middle" style={{marginBottom: 10}} />
      <CollaboratorReadOnly />
    </>
  );
};

export default CollaboReadOnlyPage;
